export const DAYS_FR = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
export const MONTHS_FR = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

export function pad(n) { return String(n).padStart(2, "0"); }

export function toISODate(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function mondayOf(d = new Date()) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  const day = x.getDay(); // 0..6, 0=Sun
  const diff = day === 0 ? -6 : 1 - day;
  x.setDate(x.getDate() + diff);
  return x;
}

export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function parseHHMM(s) {
  if (!s) return null;
  const [h, m] = s.split(":");
  return parseInt(h, 10) * 60 + parseInt(m, 10);
}

export function computeDayMinutes(e) {
  if (e && e.recovery) return 420;
  if (e && e.school) return 420;
  const a = parseHHMM(e.arrival);
  const ls = parseHHMM(e.lunch_start);
  const le = parseHHMM(e.lunch_end);
  const d = parseHHMM(e.departure);
  let total = 0;
  if (a != null && ls != null && ls > a) total += ls - a;
  if (le != null && d != null && d > le) total += d - le;
  if ((ls == null || le == null) && a != null && d != null && d > a) total = d - a;
  return Math.max(total, 0);
}

export function minutesToHM(m) {
  const h = Math.floor(m / 60);
  const min = m % 60;
  return `${h}h${pad(min)}`;
}

export function isoWeekLabel(dateISO) {
  const d = new Date(dateISO);
  const target = new Date(d.valueOf());
  const dayNr = (d.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
  }
  const week = 1 + Math.ceil((firstThursday - target) / 604800000);
  return `S${pad(week)}-${d.getFullYear()}`;
}
